export default "__VITE_ASSET__68ZP6Cdn__"